export default __webpack_public_path__ + "img/contact.760ba613.png";